import { useCommonQuery } from 'hooks';
import { ResultError } from 'modules';
import { settingKeys } from '../keys/setting.key';
import { SettingAPI } from '../apis/setting.api';
import { INation, ReqNations, ResNations } from '../models/nation';

const settingApi = new SettingAPI();

export const useFetchNations = ({ data }: { data: ReqNations }) => {
  return useCommonQuery<ReqNations, ResNations, ResultError, INation[]>({
    data: data,
    queryKeyFactory: () => settingKeys.NATION_MOBILE(data.mobile),
    queryFn: () => settingApi.fetchNations(data),
    options: {
      select: (data) => data.resultList
    }
  });
};
